import { Expose } from "class-transformer";

export class AiChatbotChunkDTO {
  @Expose()
  payload!: string;

  @Expose()
  sequenceNumber!: number;

  @Expose()
  messageId!: number;
}
